const baseURL = `${process.env.API_URL}/api`

export const apiDomainUrl = process.env.API_URL;

export const VERSION = process.env.VERSION;

export default baseURL;
